import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";

export const KeepButton = ({book})=>{
    const queryClient = useQueryClient();
    const auth = useSelector(state => state.auth);

    const keepMutate = useMutation({
        mutationFn:()=>Api.get(`/api/userBook/${book.id}/keep`),
        onSuccess:(res)=>{
            queryClient.invalidateQueries({queryKey:['userbook/list', { page: 0, list: "keep", keyword: "", sort: "updatedAt,desc", creative: "N" }]});
            book.keepCount = res.data.count;
            book.keepCheck = res.data.check;
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    });

    const onToggleKeep = () => {
        if(keepMutate.isPending)return;
        if (auth.id === book?.userId) {
            toast.warn('내 작품은 찜을 할 수 없습니다.');
            return;
        }
        keepMutate.mutate();
    }


    return (
        <button className="btn btn_keep" onClick={onToggleKeep}>
            <div className={`keep_icon ${book?.keepCheck ? 'active' : ''}`}></div><span>찜하기</span>
            {book?.keepCount > 0 && <span className="keepCount"><strong>{book?.keepCount}</strong>명</span>}
        </button>
    );
}